import {
    CREATE_PRINTING_DC2_FAILURE_DK,
    CREATE_PRINTING_DC2_REQUEST_DK,
    CREATE_PRINTING_DC2_SUCCESS_DK,
    CREATE_USER_FORM_PRINTING_DC2_DK,
    FETCH_SINGLE_PRINTING_DC2_FAILURE_DK,
    FETCH_SINGLE_PRINTING_DC2_REQUEST_DK,
    FETCH_SINGLE_PRINTING_DC2_SUCCESS_DK,
    FETCH_PRINTING_DC2_FAILURE_DK,
    FETCH_PRINTING_DC2_REQUEST_DK,
    FETCH_PRINTING_DC2_SUCCESS_DK,
    NAVIGATE_PRINTING_DC2_DETAILS_DK,
    NAVIGATE_PRINTING_DC2_DK,
    PRINTING_DC2_USERFORM_RESET_DK,
    UPDATE_PRINTING_DC2_FAILURE_DK,
    UPDATE_PRINTING_DC2_REQUEST_DK,
    UPDATE_PRINTING_DC2_SUCCESS_DK,
    DELETE_PRINTING_DC2_REQUEST_DK,
    DELETE_PRINTING_DC2_SUCCESS_DK,
    DELETE_PRINTING_DC2_FAILURE_DK,
    PRINTING_DC2_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    PRINTING_DC2_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_PRINTING_DC2_STYLE_REQUEST_DK,
    FETCH_PRINTING_DC2_STYLE_SUCCESS_DK,
    FETCH_PRINTING_DC2_STYLE_FAILURE_DK,
    FETCH_PRINTING_DC2_INVOICE_REQUEST_DK,
    FETCH_PRINTING_DC2_INVOICE_SUCCESS_DK,
    FETCH_PRINTING_DC2_INVOICE_FAILURE_DK,
    RESET_PRINTING_DC2_INVOICE_DK
} from './printingDC2.actionsType';

export const PRINTING_DC2_DK = 'printingDc2DK';

let initialState = {
    loading: false,
    printingDC2: [],
    printingDC2Invoice: [],
    printingDC2Style: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedPrintingDC2: {},
    detailsId: '',
    activeKey: 1,
    isPrintingDC2: false,
    printingDC2SelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let printingDc2DKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PRINTING_DC2_REQUEST_DK:
        case FETCH_PRINTING_DC2_INVOICE_REQUEST_DK:
        case FETCH_PRINTING_DC2_STYLE_REQUEST_DK:
        case CREATE_PRINTING_DC2_REQUEST_DK:
        case FETCH_SINGLE_PRINTING_DC2_REQUEST_DK:
        case UPDATE_PRINTING_DC2_REQUEST_DK:
        case DELETE_PRINTING_DC2_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING_DC2_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDC2: updatePayload
            };
        case FETCH_PRINTING_DC2_INVOICE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDC2Invoice: updatePayload
            };
        case FETCH_PRINTING_DC2_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDC2Style: updatePayload?.PONO
            };
        case CREATE_PRINTING_DC2_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_PRINTING_DC2_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedPrintingDC2: updatePayload,
                userform: updatePayload
            };
        case UPDATE_PRINTING_DC2_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedPrintingDC2: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_PRINTING_DC2_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedPrintingDC2: {}
            };
        case FETCH_PRINTING_DC2_FAILURE_DK:
        case FETCH_PRINTING_DC2_INVOICE_FAILURE_DK:
        case FETCH_PRINTING_DC2_STYLE_FAILURE_DK:
        case FETCH_SINGLE_PRINTING_DC2_FAILURE_DK:
        case CREATE_PRINTING_DC2_FAILURE_DK:
        case UPDATE_PRINTING_DC2_FAILURE_DK:
        case DELETE_PRINTING_DC2_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PRINTING_DC2_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_PRINTING_DC2_INVOICE_DK:
            return {
                ...state,
                printingDC2Invoice: []
            };
        case PRINTING_DC2_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                selectedPrintingDC2: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_PRINTING_DC2_DETAILS_DK:
            return {
                ...state,
                isPrintingDC2: true,
                printingDC2SelectedValue: updatePayload.printingDC2SelectedValue
            };
        case NAVIGATE_PRINTING_DC2_DK:
            return {
                ...state,
                isPrintingDC2: false
            };
        case PRINTING_DC2_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case PRINTING_DC2_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
